import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { YesNoRadioGroup } from '~/shadcn/ui/yes-no-radio-group'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepSophisticated } from '../form-step-sophisticated/useFormStepSophisticated'
import { useQuestionsV1 } from '../../questions'

const step3Schema = z.object({ experienceInLargeCompanies: z.boolean() })

export type Step3Data = z.infer<typeof step3Schema>

export function Step3() {
  const { onStepCompleted, formData } = useFormStepSophisticated()
  const question = useQuestionsV1().sophisticated.experienceInLargeCompanies

  return (
    <FormStep
      defaultValues={formData}
      schema={step3Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>{question.question.label}</StepTitle>
          <Controller
            control={control}
            name="experienceInLargeCompanies"
            render={({ field }) => (
              <YesNoRadioGroup
                value={field.value}
                labelYes={question.answers.true.label}
                labelNo={question.answers.false.label}
                onValueChange={field.onChange}
              />
            )}
          />
          <div className="flex items-center gap-2">
            <TextTooltip
              text={
                'Spoločnosť, ktorej vlastné zdroje boli 100 tisíc EUR a viac alebo ktorej čistý obrat bol vo výške 2 milióny EUR a viac alebo ktorej aktíva boli vo výške 1 milión a viac'
              }
              triggerContent="Čo znamená stredná alebo väčšia spoločnosť?"
            />
          </div>
        </>
      )}
    />
  )
}
